import { useAppDispatch, useAppSelector } from '@acorn-portal/shared/src/hooks/reduxHook';
import { getPayNowDetails } from '@acorn-portal/shared/src/store/paynow.slice';
import { useEffect, useState } from 'react';

const usePayNowDetails = (policyReference: string) => {
	const dispatch = useAppDispatch();
	const payNowDetails = useAppSelector((redux) => redux.payNow);
	const fullPolicyDetails = useAppSelector((redux) => redux.fullPolicy);
	const [loadingPayNow, setLoading] = useState(false);

	useEffect(() => {
		setLoading(true);
		if (payNowDetails.status === 'loading' || !fullPolicyDetails.isDirectDebitPaymentMethod) {
			setLoading(false);
			return;
		}

		const fetchPayNowDetails = async () => {
			if (
				(payNowDetails.details === undefined || payNowDetails.details?.policyReference !== policyReference) &&
				policyReference !== ''
			) {
				await dispatch(getPayNowDetails(policyReference));
			}
			setLoading(false);
		};

		fetchPayNowDetails().catch(console.error);
	}, [dispatch, policyReference, fullPolicyDetails.isDirectDebitPaymentMethod]);

	return { payNowDetails, loadingPayNow };
};

export default usePayNowDetails;
